import { FC, Fragment, useEffect, memo } from 'react';
import { DashboardLayout } from 'Components';
import { useLocalization, useBinListManager } from 'Hooks';
import { Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { UserState, userStore } from 'Stores/User';
import { CardTransactionsState, storeCardTransactions } from 'Stores/CardTransactions';
import {
  CreditCardTransactionsState,
  creditCardTransactionsStore,
  onGetMasterpassTokenRequest,
} from 'Stores/CreditCardTransactions';
import { MasterPassAccountStatusEnum, MasterPassTokenEnum } from 'Utils';
import { masterPassListCardNormalize } from 'Normalize';
import { MasterpassConnect } from 'Views/MasterpassConnect';
import { LoadSubscription } from './LoadSubscription';
import { UploadSubscriptionSuccess } from './UploadSubscriptionSuccess';

import './UploadSubscription.scss';

type UploadSubscriptionParams = {};

const UploadSubscription: FC<UploadSubscriptionParams> = memo(() => {
  const { web_title_upload_subscription, web_tile_subscription_success } = useLocalization();

  const dispatch = useDispatch();

  const cardData: CardTransactionsState = useSelector(storeCardTransactions);
  const isOtherCardsLoading = cardData?.otherCardStateLoading;
  const step: number = cardData?.uploadSubscriptionStep;

  const userData: UserState = useSelector(userStore);

  const creditCardData: CreditCardTransactionsState = useSelector(creditCardTransactionsStore);

  const accountStatus = creditCardData?.masterPassAccountStatus;

  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;

  // BIN listesi yönetimi için hook kullan
  useBinListManager(creditCardData.creditCardList);

  useEffect(() => {
    // NOT: Kart listesi seçim dialog'u açıldığında yükleniyor (useCreditCardList).
  }, [accountStatus]);

  return (
    <DashboardLayout backButton={step === 0}>
      <div id="uploadSubscription">
        {accountStatus === MasterPassAccountStatusEnum.NO_LINKED ? (
          <MasterpassConnect />
        ) : (accountStatus !== undefined ? (
          <Fragment>
            <Typography variant="h3" className="uploadSubscription__title">
              {step === 0 ? web_title_upload_subscription : web_tile_subscription_success}
            </Typography>

            <Fragment>
              {step === 0 && !isOtherCardsLoading && <LoadSubscription />}
              {step === 1 && <UploadSubscriptionSuccess />}
            </Fragment>
          </Fragment>
        ) : null)}
      </div>
    </DashboardLayout>
  );
});

export default UploadSubscription;
